import React from "react";

// import ArrowRight from "@/public/images/summer-promo-smartico/arrow-right.svg";

const TombolaTcRender = () => {
  const openTermsAndConditions = () => {
    const pdfUrl = "https://cdn.botb.com/media/5oipd0kk/botb-halloween-campaign-tc.pdf";
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div
        className="w-full bg-[#E7E7E9] font-jost px-4 font-normal lg:font-normal mt-auto"
        data-name={"TombolaTcRender"}>
        <div
          onClick={openTermsAndConditions}
          className="cursor-pointer max-w-fit mx-auto py-4 text-center text-gray-1 flex-center text-sm underline leading-5 lg:py-6 lg:text-base lg:leading-5.5">
          <span>View Terms and Conditions</span>
          {/*<ArrowRight />*/}
        </div>
      </div>
    </>
  );
};

export default TombolaTcRender;
